import * as React from 'react';
/** SSR-safe `matchMedia` subscription. Used for the data table's card-mode breakpoint (§5.1). */
export function useMediaQuery(query) {
    const getSnapshot = React.useCallback(() => {
        if (typeof window === 'undefined')
            return false;
        return window.matchMedia(query).matches;
    }, [query]);
    const subscribe = React.useCallback((onChange) => {
        if (typeof window === 'undefined')
            return () => { };
        const media = window.matchMedia(query);
        media.addEventListener('change', onChange);
        return () => media.removeEventListener('change', onChange);
    }, [query]);
    return React.useSyncExternalStore(subscribe, getSnapshot, () => false);
}
export function usePrefersReducedMotion() {
    return useMediaQuery('(prefers-reduced-motion: reduce)');
}
/** DESIGN_SYSTEM.md §5.1 breakpoints, as reusable predicates. */
export const BREAKPOINTS = {
    xs: 360,
    sm: 480,
    md: 768,
    lg: 1024,
    xl: 1280,
    '2xl': 1536,
};
//# sourceMappingURL=use-media-query.js.map